<template>
    <div class="my-info-account">
        <h2 class="title">{{$t('account.title')}}</h2>
        <!-- <div class="myItems">
            <span class="item1">{{$t('account.account')}}</span>
            <span class="item2" v-if="userInfo.name">{{userInfo.name}}</span>
            <el-input v-model="suserInfo.name" clearable v-else></el-input>
        </div>-->
        <div class="myItems">
            <span class="item1">{{$t('account.realName')}}</span>
            <span class="item2" v-if="userInfo.realName">{{userInfo.realName}}</span>
            <label v-else>
                <el-input v-model="suserInfo.realName" clearable></el-input>
                <span class="item3">*</span>
                <span class="item4">{{$t('account.realNameP')}}</span>
            </label>
        </div>
        <div class="myItems">
            <span class="item1">{{$t('account.nickname')}}</span>
            <span class="item2" v-if="userInfo.nickname">{{userInfo.nickname}}</span>
            <el-input v-model="suserInfo.nickname" clearable v-else></el-input>
        </div>
        <div class="myItems">
            <span class="item1">{{$t('account.phone')}}</span>
            <span class="item2" v-if="userInfo.phone">{{$utils.hideMiddle(userInfo.phone)}}</span>
            <el-input v-model="suserInfo.phone" clearable v-else maxlength="11"></el-input>
        </div>
        <div class="myItems">
            <span class="item1">{{$t('account.qq')}}</span>
            <span class="item2" v-if="userInfo.qq">{{userInfo.qq}}</span>
            <label v-else>
                <el-input v-model="suserInfo.qq" clearable></el-input>
                <!-- <span class="item3">*</span> -->
                <span class="item4">{{$t('account.qqP')}}</span>
            </label>
        </div>
        <div class="myItems">
            <span class="item1">{{$t('account.wechat')}}</span>
            <span class="item2" v-if="userInfo.wechat">{{userInfo.wechat}}</span>
            <label v-else>
                <el-input v-model="suserInfo.wechat" clearable></el-input>
                <!-- <span class="item3">*</span> -->
                <span class="item4">{{$t('account.wechatP')}}</span>
            </label>
        </div>
        <div class="myItems">
            <span class="item1">{{$t('account.email')}}</span>
            <span class="item2" v-if="userInfo.email">{{userInfo.email}}</span>
            <label v-else>
                <el-input v-model="suserInfo.email" clearable></el-input>
                <!-- <span class="item3">*</span> -->
                <span class="item4">{{$t('account.emailP')}}</span>
            </label>
        </div>

        <div class="myItems">
            <span class="item1">{{$t('account.birthday')}}</span>
            <span class="item2" v-if="userInfo.birthday">{{userInfo.birthday|timeSwitch}}</span>
            <label v-else>
                <el-date-picker
                    class="myDatePicker"
                    v-model="suserInfo.birthday"
                    type="date"
                    value-format="timestamp"
                ></el-date-picker>
                <!-- <span class="item3">*</span> -->
                <span class="item4">{{$t('registerPage.birthdayP')}}</span>
            </label>
        </div>
        <div class="mytButton" v-show="!isAllSubmit">
            <span class="btnConfirm" @click="modifyUser">{{$t('account.confirm')}}</span>
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
    data() {
        return {
            suserInfo: {
                name: "",
                realName: "",
                nickname: "",
                phone: "",
                qq: "",
                email: "",
                wechat: ""
            },
            isAllSubmit: false
        };
    },
    mounted() {
        if (
            this.userInfo.realName &&
            this.userInfo.birthday &&
            this.userInfo.nickname &&
            this.userInfo.qq &&
            this.userInfo.phone &&
            this.userInfo.wechat &&
            this.userInfo.email
        ) {
            this.isAllSubmit = true;
        }
    },
    computed: {
        ...mapGetters(["userInfo"])
    },
    filters: {
        timeSwitch(val) {
            if (val) {
                var date = new Date(val); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
                var Y = date.getFullYear() + "-";
                var M =
                    (date.getMonth() + 1 < 10
                        ? "0" + (date.getMonth() + 1)
                        : date.getMonth() + 1) + "-";
                var D =
                    date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
                var time = Y + M + D;
                return time;
            }
        }
    },
    methods: {
        phoneIsValid() {
            //手机格式校验
            return /^1[3456789]\d{9}$/.test(this.suserInfo.phone);
        },
        WeChatIsValid() {
            //微信号校验(支持纯数字)
            return /^[a-zA-Z0-9][a-zA-Z0-9_-]{5,19}$/.test(
                this.suserInfo.wechat
            );
        },
        qqIsValid() {
            //qq校验
            return /^[1-9][0-9]{4,14}$/.test(this.suserInfo.qq);
        },
        emailIsValid() {
            // email校验
            return /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/.test(
                this.suserInfo.email
            );
        },
        isNull(val) {
            return val ? val : null;
        },
        async modifyUser() {
            var _this = this;
            //正则校验
            if (this.suserInfo.phone.trim() && !this.phoneIsValid()) {
                this.$message.error(this.$t("registerPage.phoneV"));
                return;
            } else if (this.suserInfo.qq.trim() && !this.qqIsValid()) {
                this.$message.error(this.$t("registerPage.qqV"));
                return;
            } else if (this.suserInfo.wechat.trim() && !this.WeChatIsValid()) {
                this.$message.error(this.$t("registerPage.wechatV"));
                return;
            } else if (this.suserInfo.email.trim() && !this.emailIsValid()) {
                this.$message.error(this.$t("registerPage.emailV"));
                return;
            }

            var data = {
                birthday: _this.isNull(_this.suserInfo.birthday),
                email: _this.isNull(_this.suserInfo.email),
                nickname: _this.isNull(_this.suserInfo.nickname),
                phone: _this.isNull(_this.suserInfo.phone),
                qq: _this.isNull(_this.suserInfo.qq),
                realName: _this.isNull(_this.suserInfo.realName),
                userId: _this.userInfo.userId,
                wechat: _this.isNull(_this.suserInfo.wechat)
            };

            this.$nkhttp.http(this.$api.updateInfo, data, "put", data => {
                this.$message.success(this.$t("personalPage.updateSuccess"));
                this.$store.commit("updataUserInfo", data);
            });
        }
    }
};
</script>
<style lang="scss" scoped>
    @import url('../../../assets/css/common.css');
.my-info-account {
    .title {
        height: 45px;
        border-bottom: 1px solid #ddd;
        line-height: 45px;
        margin: 15px 0;
        color: #666;
        font-size: 15px;
    }
}
</style>